import { SelectV4 } from '@labrav/react-components'
import {
  AzureOfferPlan,
  AzurePricingType,
  CustomMeters,
} from '../../../../../modules/privateOffer/reducer'
import { Product } from '../../../../../modules/productsListing/reducer'
import { get } from 'lodash'
import { FormikProps, useFormikContext } from 'formik'
import { DataType } from '@labrav/react-components/lib/@types/types/forms'
import { useStyles } from './PlanRow.styles'
import { Grid, SelectChangeEvent } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { getDiscountedPriceValue } from '@labrav/common'
import { MsftCombinedFormState } from '../../../../../modules/microsoftCombinedForm/reducer'
import { PlanRowValues } from './PlanRowValues'
import { PlanRowComponent } from '../PlanRowComponent/PlanRowComponent'
import { convertProductPlanToOfferPlan } from '../ContractDetail/ContractDetail'

export const PlanRow = ({
  plan,
  index,
  product,
  planIds,
  remove,
}: {
  plan: AzureOfferPlan
  index: number
  product: Product
  planIds: string[]
  remove?: <X = any>(index: number) => X | undefined
}) => {
  const { classes } = useStyles()
  const { values, touched, errors, handleBlur, setFieldValue } =
    useFormikContext() as FormikProps<MsftCombinedFormState>

  const plans = (values?.draftOffer?.plans || []) as AzureOfferPlan[]

  const productPlans = (
    product?.plans?.filter(plan => !planIds.includes(plan?.planId)) || []
  )?.filter(
    plan => !(plan?.isPrivate || plan?.isStopSell || plan?.hasFreeTrials)
  )

  const mappedProductPlans = productPlans.map(planItem => ({
    label: planItem?.displayName,
    value: planItem?.planId,
  }))

  const handleChangePlanSelection = (e: SelectChangeEvent) => {
    const selectedPlan = product?.plans?.find(
      item => item?.planId === e.target.value
    )
    if (selectedPlan) {
      const offerPlan = convertProductPlanToOfferPlan(selectedPlan)

      setFieldValue(`draftOffer.plans.${[index]}`, {
        ...offerPlan,
        discountPercentage: 0,
        markupPercentage: 0,
        discountType: AzurePricingType.ABSOLUTE,
        buyerPrice:
          offerPlan?.pricing?.recurrentPrice?.prices[0]?.pricePerPaymentInUsd,
      })
    }
  }

  return (
    <>
      <div className={classes.planRowWrapper} data-testid={'plan-row'}>
        <div className={classes.header}>
          <div className={classes.plansHeading}>Plan {index + 1}</div>
          <div>
            {plans.length > 1 && (
              <FontAwesomeIcon
                icon={faTrash}
                style={{
                  width: '14px',
                  height: '20px',
                  color: '#6A777A',
                  cursor: 'pointer',
                }}
                data-testid="trash-metaData"
                onClick={() => remove && remove(index)}
              />
            )}
          </div>
        </div>
        <div className={classes.planSectionWrapper}>
          <div className={classes.planSectionHeading}>Plan details</div>
          <Grid container width={'100%'} spacing={3}>
            <Grid size={4}>
              <div className={classes.planSelect}>
                <SelectV4
                  field={{
                    title: 'Select plan',
                    placeHolder: 'Select plan',
                    humanReadableKey: 'plan',
                    id: `draftOffer.plans.${[index]}.labraPlanId`,
                    isRequired: false,
                    isReadOnly: false,
                    isCustom: false,
                    defaultValue: '',
                    dataType: 'enum' as DataType,
                    options: mappedProductPlans,
                  }}
                  size="small"
                  value={plan?.displayName || ''}
                  onChange={handleChangePlanSelection}
                  onBlur={handleBlur}
                  isError={
                    !!(
                      get(
                        touched,
                        `draftOffer.plans.${[index]}.labraPlanId`,
                        false
                      ) &&
                      get(
                        errors,
                        `draftOffer.plans.${[index]}.labraPlanId`,
                        false
                      )
                    )
                  }
                  errorText={
                    (!!get(
                      touched,
                      `draftOffer.plans.${[index]}.labraPlanId`,
                      false
                    ) &&
                      get(
                        errors,
                        `draftOffer.plans.${[index]}.labraPlanId`,
                        ''
                      )) ||
                    ''
                  }
                />
              </div>
            </Grid>
            {plan?.labraPlanId && (
              <>
                <PlanRowValues plan={plan} index={index} product={product} />
              </>
            )}
          </Grid>
        </div>
        {plan?.labraPlanId && (
          <PlanRowComponent index={index} plan={plan} product={product} />
        )}
      </div>
    </>
  )
}

export const getUpdatedCustomMeters = (
  plan: AzureOfferPlan,
  discountPercentage?: number,
  customMeters?: CustomMeters
) => {
  let updatedCustomMeters = customMeters
  if (customMeters?.meters && Object.keys(customMeters?.meters).length > 0) {
    const originalCustomMeters = plan.originalPricing?.customMeters?.meters
    if (originalCustomMeters) {
      const updatedMeters = { ...customMeters?.meters }

      Object.keys(updatedMeters).forEach(meterKey => {
        const originalMeter = originalCustomMeters[meterKey]
        if (originalMeter?.pricePerPaymentInUsd) {
          const discountedMeterPrice = getDiscountedPriceValue({
            price: originalMeter.pricePerPaymentInUsd,
            discount: discountPercentage || 0,
          })

          updatedMeters[meterKey] = {
            ...updatedMeters[meterKey],
            pricePerPaymentInUsd: discountedMeterPrice,
          }
        }
      })

      updatedCustomMeters = {
        ...customMeters,
        meters: updatedMeters,
      }
    }
  }
  return updatedCustomMeters
}
